// import axios from 'axios';
import React from 'react'
import { useState } from 'react';
import { getApiData } from '../../api/api';
import './PolicySearch.css';
import { generateCorrelationId } from "../../utils/correlationId";
import { compose } from 'redux';
import { connect } from 'react-redux';
import { showLoader } from "../../redux/actions/action_loader";
import { policy_search_header } from '../../images/images'
import Tnc from './Tnc/TnC';
import PayNow from './PayNow/PayNow';
import Snackbar from '../Snackbar/Snackbar'
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import { getDevice } from '../../utils/getDevice';
import AxiosRequest from "../../utils/axios";
import { getConfigFromParamStore, getConfigFromStroage } from '../../utils/getUrlsFromAws';
import { Button } from 'unified-ui-components-library';

const axios = new AxiosRequest().getClient()

const useStyles = makeStyles((theme) => ({
    root: {
        '& > *': {
            margin: theme.spacing(1),
            width: getDevice() == "mobile" ? "100%" : "70%",
        },
    },

}));


function PolicySearch(props) {
    const classes = useStyles();

    const [policyNumber, setPolicyNumber] = useState("");
    const [msg, setMsg] = useState("");
    const [error, setError] = useState(false);
    const [policyNumErr, setPolicyNumError] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const [showTnc, setShowTnc] = useState(false)
    const [checked, setChecked] = useState(false)
    const [showPaynow, setShowPaynow] = useState(false)
    const [errorMsgType, setErrorMsgType] = useState("");

    const validatePolicyNumber = (value) => {
        if (value.length == 9) {
            setPolicyNumError(false);
            setMsg("");
        } else {
            setPolicyNumError(true);
            setMsg("Policy number should be 9 digit long.");
        }
    }
    const handleSubmit = async (e) => {
        e.preventDefault();
        setMsg("");
        props.showLoader(true);
        setSubmitting(true);
        setError(false);
        let urlsData = getConfigFromStroage();
        if (!urlsData) {
            const resp = await getConfigFromParamStore()
        }
        const { url } = getApiData("policySearch");
        let body = {
            request: { header: { correlationId: generateCorrelationId(), appId: "mpro" }, payload: {} },
        }
        body.request.payload.proposalNo = policyNumber;
        body.request.payload.policy360 = 'Y';
        try {
            const response = await axios.post(url, body);
            if (response.data.response.msgInfo.msgCode == 200) {
                // setError(false);
                // setMsg(response.data.response.payload.businessMsg);
                handleSnackbar(true, "success", response.data.response.payload.businessMsg)
                // setShowPaynow(true)
            } else {
                handleSnackbar(true, "error", response.data.response.payload.businessMsg)
                // setError(true);
                // setMsg(response.data.response.payload.businessMsg);
                setShowPaynow(false)
            }


        } catch (err) {
            handleSnackbar(true, "error", "Something went wrong,Please try after some time.")
            // setError(true);
            // setMsg("Something went wrong,Please try after some time.");
        } finally {
            props.showLoader(false);
            setSubmitting(false);
        }
    }

    const handleSnackbar = (err, msgType, msg) => {
        setError(err)
        setErrorMsgType(msgType)
        setMsg(msg)
        setTimeout(() => {
            closeSnackbar();
            if (msgType == "success") {
                setShowPaynow(true)
            }
        }, 2000);

    };

    const closeSnackbar = () => {
        setError(false)
        setMsg("")
    };

    return (<>

        {showPaynow ? <PayNow /> :
            <div className="policy-cntnr">
                <div className="policy-search-header">
                    <p className="header-text">
                        Finding it difficult to pay your premium?
                    </p>
                    <img className='header-img' src={policy_search_header} alt="" />
                </div>

                <div className="policy-heading-cntnr" >
                    <p className="heading-text">
                        ULIP Cover Continuance Scheme
                    </p>
                    <p className='sub-heading-text'>Utilise the total accumulated fund value in excess of premium paid of your policy to pay the due premium</p>
                    <div className="partition-line"></div>
                </div>

                <div className="policy-search-cntnr">
                    <div className="policyNumber-input">
                        <label className='policy-search-label' htmlFor="policyNumber">Enter your Policy Number to submit your consent for ULIP Continuance Scheme</label>
                        <div className={`${classes.root} input-div`} autoComplete="off">
                            <TextField variant="filled" label="Policy Number" type="number" id="policyInput" value={policyNumber} InputLabelProps={{ className: "inputBox" }} InputProps={{ disableUnderline: true }} {...props}
                                onChange={(e) => {
                                    validatePolicyNumber(e.target.value)
                                    setPolicyNumber(e.target.value)
                                }} />
                        </div>
                        {error ? <Snackbar
                            closeSnackbar={closeSnackbar}
                            snackbarMsgType={errorMsgType}
                            snackbarMsg={msg}
                        /> : null}
                        <div className="msg">
                            {policyNumErr && <p className={policyNumErr ? "error-msg" : "success-msg"}>{msg}</p>}
                        </div>
                    </div>
                    <div className="policyNumber-checkbox">
                        <input checked={checked} onChange={(e) => setChecked(e.target.checked)} className='policy-search-checkbox' id="tandc" type="checkbox" placeholder="Policy Number" />
                        <label className='policy-search-checkbox-label' htmlFor="tandc">I agree to the </label>
                        <span className='tnc-underlined' onClick={() => setShowTnc(!showTnc)} >  Terms and Conditions</span>
                    </div>
                    {showTnc ? <Tnc /> : null}
                    <div className="button_div_unified">
                        <Button
                            // className='policy-search-btn'
                            type="submit"
                            onClick={handleSubmit}
                            disabled={!checked || (policyNumber.length != 9 ? true : false || submitting)}
                            buttonType='primary'
                            width="264"
                        >
                            Submit
                        </Button>
                    </div>
                    <p className='redirect-msg' >You’ll be redirected to the payment page to pay your remaining due</p>

                </div>

            </div>
        }
    </>
    )
}

export default compose(
    connect(null, { showLoader }),
)(PolicySearch);


